<div class="card-container">
    <div class="left-static" id="leftStatic" style="z-index:900;" [ngStyle]="pageOpened ? leftStaticStyle : pageClosedStyleLeft">
    </div>
    <div class="left-transit" id="leftTransit" #leftTransit style="z-index:900;" (click)="leftTransitClick()" [ngStyle]="pageOpened ? leftTransitStyle : pageClosedStyleLeft">
    </div>
    <div class="right-static" id="rightStatic" style="z-index:900;" [ngStyle]="pageOpened ? rightStaticStyle : pageClosedStyleRight">
    </div>
    <div class="right-transit" id="rightTransit" #rightTransit style="z-index:900;" (click)="rightTransitClick()" [ngStyle]="pageOpened ? rightTransitStyle : pageClosedStyleRight">
    </div>
  </div>